export default __webpack_public_path__ + "static/media/Forecasting the Impacts of CCAM.b7f272b6.pdf";